import type { BridgeError } from "owa-nested-app-auth-types";
import { BridgeStatusCode } from "owa-nested-app-auth-types/lib/msal-types/BridgeStatusCode";
import createBridgeError from "./createBridgeError";

export function buildUnexpectedBridgeError(subError: string, description: string, properties: object = {}): BridgeError {
    return createBridgeError(BridgeStatusCode.PersistentError, "unexpected_bridge_error", subError, description, properties);
}
